import { chain, UpdateCart } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import {markSkipOnCompleteIfOnErrorIsSet, replaceInChain} from "@insite/client-framework/HandlerCreator";
import {updateCartWithResult} from "@insite/client-framework/Services/CartService";

declare global {
    interface Window {
        dataLayer: Record<string, any>[];
    }
}

type HandlerProps = Parameters<typeof UpdateCart>[0];

// Copied from source code
const UpdateCartOverride = async (props: HandlerProps) => {
    const result = await updateCartWithResult(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
        props.dispatch({
            type: "Data/Carts/ResetCart",
            id: props.apiParameter.cart.id,
        });
        OrderSubmitSuccessGA(props);
        
    } else {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.();
        props.dispatch({
            type: "Pages/CheckoutReviewAndSubmit/FailedToPlaceOrder",
            errorMessage: result.errorMessage,
        });
        
        OrderSubmitFailedGA(props);
        return false;
    }
};


const OrderSubmitSuccessGA = (props: HandlerProps) => {
    window.dataLayer = window.dataLayer || [];
    const state = props.getState();
    
    window.dataLayer.push({
        "event": "checkout_success",
        "cart_id": props.cartToUpdate.id,
        "cart_items": props.cartToUpdate.cartLines?.length,
        "currency": state.context.session.currency?.currencyCode,
        "products": props.cartToUpdate.cartLines?.map(l => { return {
            "name": l.productName,
            "product_number": l.erpNumber,
            "price": l.pricing?.unitListPrice,
            "quantity": l.qtyOrdered
        }})
    });
}

const OrderSubmitFailedGA = (props: HandlerProps) => {
    window.dataLayer = window.dataLayer || [];
    const state = props.getState();
    
    window.dataLayer.push({
        "event": "checkout_failed",
        "cart_id": props.cartToUpdate.id,
        "cart_items": props.cartToUpdate.cartLines?.length,
        "currency": state.context.session.currency?.currencyCode,
        "products": props.cartToUpdate.cartLines?.map(l => { return {
            "name": l.productName,
            "product_number": l.erpNumber,
            "price": l.pricing?.unitListPrice,
            "quantity": l.qtyOrdered
        }})
    });
}

replaceInChain(chain, UpdateCart, UpdateCartOverride)